import { fontWeight } from "../../../../constants/typography";
import styled from 'styled-components';
import { Typography as BaseTypography } from "../../typography.styles";
export var Typography = styled(BaseTypography).withConfig({
  componentId: "sc-1g2393e-0"
})(["font-weight:", ";text-decoration:", ";"], function (_ref) {
  var emphasised = _ref.emphasised;
  return emphasised ? fontWeight.bold : fontWeight.regular;
}, function (_ref2) {
  var underlined = _ref2.underlined;
  return underlined ? 'underline' : 'none';
});